import React from "react";
import "./LoadingSpinner.scss";

export const LoadingSpinner = () => {
  return (
    <div className="c-loading-spinner">
      <img className="inline-block lazyload" src="/ui/css/img/loader.gif" alt="Loading" />
    </div>
  );
};
